import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import Layout from "@/components/site/Layout";

export default function Dashboard() {
  const [data, setData] = useState(null);
  const [notifs, setNotifs] = useState([]);
  useEffect(() => {
    api.get("/me/dashboard").then(r => setData(r.data));
    api.get("/notifications").then(r => { setNotifs(r.data); api.post("/notifications/read").catch(()=>{}); });
  }, []);
  if (!data) return <Layout><div className="p-24 text-center overline">Loading…</div></Layout>;
  const { user, transactions, unlocks_count, votes_count } = data;

  return (
    <Layout>
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 pb-24">
        <div className="overline mb-3">Member · {user.email}</div>
        <h1 className="font-serif-editorial text-5xl md:text-7xl tracking-tighter mb-16">
          Your <em className="italic text-neutral-400">ledger</em>.
        </h1>

        <div className="grid md:grid-cols-4 gap-px bg-white/10 mb-16">
          <Stat label="Credits" value={user.credits} testId="stat-credits"/>
          <Stat label="Subscription" value={user.subscription_tier || "None"} testId="stat-tier"/>
          <Stat label="Unlocks" value={unlocks_count} testId="stat-unlocks"/>
          <Stat label="Votes cast" value={votes_count} testId="stat-votes"/>
        </div>

        <div className="grid md:grid-cols-2 gap-16">
          <div>
            <div className="overline mb-4">Actions</div>
            <div className="space-y-2">
              <Link to="/pricing" className="btn-white w-full !justify-between" data-testid="dash-upgrade">Upgrade / Top up →</Link>
              <Link to="/models" className="btn-ghost w-full !justify-between">Continue browsing →</Link>
              <Link to="/vote" className="btn-ghost w-full !justify-between">Vote on teasers →</Link>
            </div>
            {notifs.length > 0 && (
              <div className="mt-10">
                <div className="overline mb-4">Notifications</div>
                <div className="border border-white/10 divide-y divide-white/10" data-testid="dash-notifications">
                  {notifs.slice(0,8).map(n => (
                    <div key={n.notif_id} className="p-4 text-sm">
                      <div className="text-white">{n.message}</div>
                      <div className="text-xs text-neutral-500 font-mono-ui mt-1">{new Date(n.created_at).toLocaleString()}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div>
            <div className="overline mb-4">Recent transactions</div>
            <div className="border border-white/10 divide-y divide-white/10">
              {transactions.length === 0 && <div className="p-6 text-neutral-500 text-sm">No transactions yet.</div>}
              {transactions.slice(0, 12).map(t => (
                <div key={t.tx_id} className="p-4 flex items-center justify-between text-sm">
                  <div>
                    <div className="font-mono-ui text-xs uppercase tracking-widest text-neutral-500">{t.type.replace("_"," ")}</div>
                    <div className="text-neutral-400 text-xs mt-1">{new Date(t.created_at).toLocaleString()}</div>
                  </div>
                  <div className="text-right">
                    {t.credits_spent ? <span className="text-white">-{t.credits_spent}¢</span> : null}
                    {t.credits_gained ? <span className="text-white">+{t.credits_gained}¢</span> : null}
                    {t.amount ? <div className="text-neutral-500 text-xs">${t.amount}</div> : null}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

function Stat({ label, value, testId }) {
  return (
    <div className="bg-black p-8" data-testid={testId}>
      <div className="overline">{label}</div>
      <div className="font-serif-editorial text-4xl mt-3">{value}</div>
    </div>
  );
}
